import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroupDirective, NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { ApplicationTypes } from 'projects/admin/src/app/models/exemptionFilling';
import { YesNoModalComponent } from 'projects/admin/src/app/shared/yes-no-modal/yes-no-modal.component';
import { forkJoin } from 'rxjs';
import { ExternalFilingRequestService } from '../../shared/services/exemptionFilingRequest';
import { ExternalCommonService } from '../../shared/services/external.common.service';

@Component({
  selector: 'app-registry-download-payment',
  templateUrl: './registry-download-payment.component.html',
  styleUrls: ['./registry-download-payment.component.scss']
})
export class RegistryDownloadPaymentComponent implements OnInit {
  requestId: any;
  data: any;
  fisPayment: any;
  feeApplied: any;
  amount: any;
  @ViewChild('formRef')
  formRef: FormGroupDirective | undefined;
  name = "";
  isLoading = false;
  downloadType = '';
  fee: any;
  constructor(
    private dialog: MatDialog,
    private commonService: ExternalCommonService,
    private routerService: Router,
    private router: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.requestId = +atob(this.router.snapshot.params.id);
    this.isLoading = true;
    forkJoin({
      exemptionData:
        this.commonService.getRegistryDownload(
          this.requestId
        ),
      fis: this.commonService.getFisPay(
        this.requestId
      ),
    }).subscribe(({ exemptionData, fis }) => {
      this.data = exemptionData;
      this.fisPayment = fis;
      if (this.data.downloadTypeId == 1) {
        this.amount = 1000;
        this.downloadType = 'Full Registry Download Fee';
      } else if(this.data.downloadTypeId == 2) {
        this.amount = 50;
        this.downloadType = 'Prior Month\'s Registry Activity Fee';
      } else {
        this.amount = 50;
        this.downloadType = 'Prior Week\'s Registry Activity Fee';
      }
      this.fee = parseFloat(this.amount * 0.0229+"").toFixed(2);
      this.feeApplied = parseFloat(this.amount + (this.amount * 0.0229)).toFixed(2);
      this.name += this.data?.signatureFirstName;
      if (this.data?.signatureMiddleName)this.name += " " + this.data?.signatureMiddleName;
      this.name += " " + this.data?.signatureLastName;
      if (this.data?.signatureSuffix)this.name += "," + this.data?.signatureSuffix;
      this.isLoading = false;
    });
  }


  onBack() {
  }
}
//amount + (amount*0.0229) | number:'2.0-2'